import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import reportManagementService from "services/reportManagementService";

// List Report
export const useListReport = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["reportManagement"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["reports", params?.page],
    () => reportManagementService.listReport(payload),
    {
      enabled: false,
      cacheTime: 0,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("report"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

// Download Report
export const useDownloadReport = (onSuccess, onError) => {
  const { t } = useTranslation(["reportManagement"]);
  const { addToast } = useToasts();

  return useMutation(reportManagementService.downloadReport, {
    retry: 0,
    onSuccess: (response, variables) => {
      const { data } = response;
      if (
        !data.size ||
        data.size === undefined ||
        data.size === null ||
        data.size === 0
      ) {
        addToast(
          formConvertErrorMessage(
            t("message.download", {
              target: t("report"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        return;
      }

      addToast(
        t("message.download", {
          target: t("report"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );

      if (typeof onSuccess === "function") {
        onSuccess({
          fileName: variables.fileName,
          file: data,
          fileUrl: URL.createObjectURL(data),
        });
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.download", {
              target: t("report"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Export Statistical Report
export const useExportStatisticalReport = (onSuccess, onError) => {
  const { t } = useTranslation(["reportManagement"]);
  const { addToast } = useToasts();

  return useMutation(reportManagementService.exportStatisticalReport, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;
      // if (!data.status) {
      //   addToast(
      //     formConvertErrorMessage(
      //       t("message.export_report", {
      //         target: t("report"),
      //         status: t("message.error"),
      //       }),
      //       t
      //     ),
      //     {
      //       appearance: "error",
      //       autoDismiss: true,
      //     }
      //   );
      // } else {
      addToast(
        t("message.export_report", {
          target: t("report"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      // }

      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.export_report", {
              target: t("report"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );

      // if (errorResponse.code === 422 && errorResponse.fields.length > 0) {
      //   errorResponse.fields.forEach(item => {
      //     switch (item.field) {
      //       case "filter":
      //         addToast(item.message, {
      //           appearance: "error",
      //           autoDismiss: true,
      //         });
      //         break;
      //       default:
      //         break;
      //     }
      //   });
      // }
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// List Type Report
export const useListTypeReport = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["reportManagement"]);
  const { addToast } = useToasts();

  return useQuery(
    ["report-types", "all"],
    () => reportManagementService.listTypeReport(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("type_report"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data || [],
        };
      },
    }
  );
};

// Detail Report
export const useDetailReport = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["reportManagement"]);
  const { addToast } = useToasts();

  return useQuery(
    ["report", "detail"],
    () => reportManagementService.detailReport(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.detail", {
                target: t("report"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};
